export default __webpack_public_path__ + "static/media/copyright.0c48f859.svg";